import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';

export const Footer: React.FC = () => {
  const location = useLocation();

  return (
    <footer className="bg-brand-dark-blue text-brand-white pt-20 pb-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-6">
          <Link 
            to="/" 
            className="flex items-center transition-opacity hover:opacity-90" 
            aria-label="Ir al inicio de MULTIMACK"
            onClick={() => {
              if (location.pathname === '/') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            <img 
              src="/images/logo.webp" 
              alt="Logo MULTIMACK Footer" 
              className="h-12 w-auto object-contain brightness-0 invert" 
              width="180"
              height="48"
            />
          </Link>
          <p className="text-brand-white/70 text-sm leading-relaxed max-w-sm">
            Líderes en envases y suministros para negocios gastronómicos en Chile. Desde 2017 atendiendo personas, no solo pedidos.
          </p>
          <div className="flex gap-4">
            <a href="https://www.instagram.com/envases_multimack?igsh=MTY4eHBnNTF1cHZzZw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="bg-brand-white/10 p-2 rounded-lg hover:bg-brand-green hover:text-brand-dark-blue transition-colors" aria-label="Visitar nuestro Instagram">
              <Instagram size={20} aria-hidden="true" />
            </a>
            <a href="https://www.facebook.com/multimack.los.libertadores.2025" target="_blank" rel="noopener noreferrer" className="bg-brand-white/10 p-2 rounded-lg hover:bg-brand-green hover:text-brand-dark-blue transition-colors" aria-label="Visitar nuestro Facebook">
              <Facebook size={20} aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="text-center md:text-left">
          <h4 className="font-bold text-lg mb-6">Navegación</h4>
          <ul className="space-y-4 text-sm text-brand-white/70">
            <li><Link to="/productos" className="hover:text-brand-green transition-colors">Productos</Link></li>
            <li><Link to="/ofertas" className="hover:text-brand-green transition-colors">Ofertas</Link></li>
            <li><Link to="/sectores" className="hover:text-brand-green transition-colors">Sectores</Link></li>
            <li><Link to="/blog" className="hover:text-brand-green transition-colors">Blog</Link></li>
            <li><Link to="/nosotros" className="hover:text-brand-green transition-colors">Nosotros</Link></li>
          </ul>
        </div>

        <div className="text-center md:text-left">
          <h4 className="font-bold text-lg mb-6">Contacto</h4>
          <ul className="space-y-4 text-sm text-brand-white/70">
            <li className="flex items-center justify-center md:justify-start gap-3">
              <Phone size={16} className="text-brand-green" aria-hidden="true" />
              <a href="tel:+56948758084" className="hover:text-brand-green transition-colors">+56 9 4875 8084</a>
            </li>
            <li className="flex items-center justify-center md:justify-start gap-3">
              <Mail size={16} className="text-brand-green" aria-hidden="true" />
              <a href="mailto:contacto@multimack.cl" className="hover:text-brand-green transition-colors">contacto@multimack.cl</a>
            </li>
            <li className="flex items-start justify-center md:justify-start gap-3 text-center md:text-left">
              <MapPin size={16} className="text-brand-green mt-1 flex-shrink-0" aria-hidden="true" />
              <div className="flex flex-col gap-0.5">
                <span className="font-semibold text-brand-white">Av. Los Libertadores 282, El Monte</span>
                <span className="text-[11px] opacity-60">Santiago, Chile (Cobertura Nacional)</span>
              </div>
            </li>
          </ul>
        </div>

        <div className="text-center md:text-left">
          <h4 className="font-bold text-lg mb-6">Horarios</h4>
          <ul className="space-y-4 text-sm text-brand-white/70">
            <li>Lunes a Viernes: 08:30 - 20:00</li>
            <li>Sábados: 09:00 - 20:00</li>
            <li>Domingos: Cerrado</li>
          </ul>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-brand-white/10 flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-brand-white/40">
        <div>
          © {new Date().getFullYear()} MULTIMACK. Todos los derechos reservados. Diseñado para el éxito gastronómico.
        </div>
        <div className="flex flex-wrap justify-center gap-6">
          <Link to="/terminos" className="hover:text-brand-green transition-colors">Términos y Condiciones</Link>
          <Link to="/privacidad" className="hover:text-brand-green transition-colors">Política de Privacidad</Link>
          <Link to="/seguridad" className="hover:text-brand-green transition-colors">Políticas de Seguridad</Link>
        </div>
      </div>
    </footer>
  );
};
